import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { StatusTag } from '@factorialco/factorial-one-react/dist/experimental'
import { AtsJobApplicationFilesDiscTestFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { statusColor, statusLabel } from 'modules/ats/components/AssessmentStatusTag'

interface Props {
  assessment: AtsJobApplicationFilesDiscTestFragment
}
export const DiscTest: React.FC<Props> = ({ assessment }) => {
  const { reportUrl, status } = assessment

  return (
    <>
      <Text.Normal color="textPrimary" weight="semibold">
        {i18n.t('ats.application_details.disc_test.title')}
      </Text.Normal>
      <Box
        flexDirection="row"
        gap="s2"
        paddingX="s16"
        paddingY="s12"
        justifyContent="spaceBetween"
        width="full"
        alignItems="center"
        borderRadius={{ all: 'abs016' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
      >
        <Text.Normal size="200" weight="medium" color="textPrimary">
          {i18n.t('ats.application_details.disc_test.title')}
        </Text.Normal>
        <Box flexDirection="row" gap="s12" justifyContent="flexEnd">
          <StatusTag text={statusLabel(status)} variant={statusColor(status)} />
          <Button.Router
            to={reportUrl ?? ''}
            rel="nofollow noopener noreferrer"
            type="secondary"
            iconName="link"
            blankTarget
            disabled={!reportUrl || status !== 'completed'}
          />
        </Box>
      </Box>
    </>
  )
}
